module.exports = __webpack_public_path__ + "static/media/WeddingPlanners.6d73bca4.png";